import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';

class ApplicationErrorBoundary extends React.Component {
    componentDidCatch() {}

    render() {
        const { children, fallback, capture } = this.props;

        if (!capture) {
            return children;
        }

        return (
            <Sentry.ErrorBoundary
                fallback={fallback}
                onError={typeof capture === 'function' ? capture : undefined}>
                {children}
            </Sentry.ErrorBoundary>
        );
    }
}

ApplicationErrorBoundary.propTypes = {
    // Capture function, if false then errors are silently ignored
    capture: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
    fallback: PropTypes.node
};

ApplicationErrorBoundary.defaultProps = {
    capture: true,
    fallback: null
};

export default ApplicationErrorBoundary;
